// extracted by mini-css-extract-plugin
module.exports = {"CertificatesWrapper":"styles_CertificatesWrapper__1v9LW"};